/* =========================================================
   CUS Bare Root Trees
   Separate JavaScript for the Shopify section
   ========================================================= */

(function () {
  'use strict';

  function destroyPlayer(player) {
    if (!player) return;

    var iframe = player.querySelector('iframe');

    if (iframe) {
      iframe.src = '';
      iframe.remove();
    }

    var video = player.querySelector('video');

    if (video) { 
      video.pause();
      video.removeAttribute('src');
      video.load();
      video.remove();
    }

    player.innerHTML = '';
  }


  function initSection(section) {
    if (!section || section.dataset.cusInitialized === 'true') {
      return;
    }

    section.dataset.cusInitialized = 'true';

    var cards = section.querySelectorAll('[data-video-card]');

    cards.forEach(function (card) {

      var playButtons = card.querySelectorAll('[data-play-video]');
      var closeButton = card.querySelector('[data-close-video]');
      var player = card.querySelector('[data-video-player]');

      var youtubeId = (card.dataset.youtubeId || '').trim();
      var videoUrl = (card.dataset.videoUrl || '').trim();


      /* -----------------------------------------------------
         Open video
         ----------------------------------------------------- */

      function openVideo() {

        if (!player || (!youtubeId && !videoUrl)) {
          return;
        }

        destroyPlayer(player);


        /* YouTube video */

        if (youtubeId) {

          var iframe = document.createElement('iframe');

          iframe.src =
            'https://www.youtube.com/embed/' +
            encodeURIComponent(youtubeId) +
            '?autoplay=1&rel=0';

          iframe.title = 'Farm video';

          iframe.allow =
            'autoplay; encrypted-media; picture-in-picture';

          iframe.allowFullscreen = true;

          player.appendChild(iframe);

        }


        /* Self-hosted video */

        else {

          var video = document.createElement('video');

          video.src = videoUrl;
          video.autoplay = true;
          video.controls = true;
          video.playsInline = true;

          player.appendChild(video);


          var playPromise = video.play();

          if (
            playPromise &&
            typeof playPromise.catch === 'function'
          ) {
            playPromise.catch(function () {});
          }
        }


        card.classList.add('is-playing');

        player.setAttribute(
          'aria-hidden',
          'false'
        );
      }


      /* -----------------------------------------------------
         Close video
         ----------------------------------------------------- */

      function closeVideo() {

        destroyPlayer(player);

        card.classList.remove('is-playing');

        if (player) {
          player.setAttribute(
            'aria-hidden',
            'true'
          );
        }
      }


      /* -----------------------------------------------------
         Play buttons
         ----------------------------------------------------- */

      playButtons.forEach(function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            openVideo();
          }
        );

      });


      /* -----------------------------------------------------
         Close button
         ----------------------------------------------------- */

      if (closeButton) {

        closeButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            closeVideo();
          }
        );

      }


      /* -----------------------------------------------------
         Escape key
         ----------------------------------------------------- */

      card.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Escape' &&
            card.classList.contains('is-playing')
          ) {
            closeVideo();
          }

        }
      );

    });
  }


  /* ---------------------------------------------------------
     Initialize all sections
     --------------------------------------------------------- */

  function initAll() {

    document
      .querySelectorAll('.cus-bare-root-trees')
      .forEach(initSection);

  }


  /* ---------------------------------------------------------
     Initial page load
     --------------------------------------------------------- */

  document.addEventListener(
    'DOMContentLoaded',
    initAll
  );


  /* ---------------------------------------------------------
     Shopify Theme Editor support
     --------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section = event.target.querySelector
        ? event.target.querySelector(
            '.cus-bare-root-trees'
          )
        : null;

      if (section) {
        initSection(section);
      }

    }
  );


  /* ---------------------------------------------------------
     Shopify section unload
     --------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      var section = event.target.querySelector
        ? event.target.querySelector(
            '.cus-bare-root-trees'
          )
        : null;

      if (!section) {
        return;
      }

      section
        .querySelectorAll('[data-video-player]')
        .forEach(function (player) {

          destroyPlayer(player);

        });

    }
  );

})();